// extracted by mini-css-extract-plugin
export default {"componentWrapper":"SearchInput_componentWrapper__G+n5i","form":"SearchInput_form__CoxTk","searchButton":"SearchInput_searchButton__cYvkV","input":"SearchInput_input__a6Hm5"};